export default __webpack_public_path__ + "static/media/SourceHanSansCN-Normal.aac26a32.otf";